import { Checkbox, Select, Stack } from '@mantine/core';
import { UseFormReturnType as Form } from '@mantine/form';
import { IAutomationSetFileName } from 'pages/revisions-module/template-editor/editors/pipeline/types';
import { useMemo } from 'react';
import { useFormInputs } from 'pages/revisions-module/template-editor/editors/form/input/FormInputsDataProvider';
import P4Regular from 'components/typography/P4Regular';

/** Input spec types whose runtime value is a plain string usable as a file name. */
const TEXT_TYPES = new Set(['text', 'textExpression', 'constant', 'select']);

/**
 * Sub-form for set-file-name automation.
 */
export default function SetFileNameSubForm({ form }: { form: Form<IAutomationSetFileName> }) {
  const { allInputs } = useFormInputs();

  const inputData = useMemo(
    () =>
      allInputs
        .filter((input) => input.context === 'revision' && TEXT_TYPES.has(input.spec.type))
        .map((input) => ({ value: input.spec.name, label: input.spec.label })),
    [allInputs]
  );

  return (
    <Stack spacing={12}>
      <Stack spacing={4}>
        <Select
          data={inputData}
          label="Pole s názvom súboru"
          placeholder="Vyberte pole"
          required
          searchable
          size="sm"
          {...form.getInputProps('inputName')}
        />
        <P4Regular color="gray.6">Hodnota poľa bude použitá ako názov vygenerovaného PDF súboru</P4Regular>
      </Stack>
      <Checkbox
        label="Pridať timestamp ako prefix názvu súboru"
        size="sm"
        {...form.getInputProps('timestampPrefix', { type: 'checkbox' })}
      />
    </Stack>
  );
}
